import { Box } from "@material-ui/core";
import React from "react";
import { Link } from "react-router-dom";

const CustomButton = ({
  btnText = "Read",
  btnURL = "https://donate.akhuwat.org.pk/",
  btnColor = "white",
  btnBackground = "customBlack",
}) => {
  const buttonClasses = `lg:h-[59px] h-10 lg:px-8 px-6 lg:py-4 py-3 flex items-center justify-center rounded-full font-manrope
  text-[14px] lg:text-[18px] font-bold leading-[28px]
  bg-${btnBackground} text-${btnColor}
  transition-all duration-300 ease-in-out
  hover:text-white 
  hover:bg-gradient-to-r hover:from-[#96C949] hover:via-[#329A51] hover:to-[#00f304]
  hover:scale-105 hover:shadow-lg`;

  // Check if the URL is external (starts with "http:// or https://")
  const isExternal = btnURL.startsWith("http://") || btnURL.startsWith("https://");

  return (
    <Box>
      {isExternal ? (
       <a
          href={btnURL}
          target="_blank" // Open in a new tab
          rel="noopener noreferrer" // For security purposes
          className={buttonClasses}
       
        
        >
          {btnText}
        </a>
        
      ) : (
        <Link className={buttonClasses} to={btnURL}>
          {btnText}
        </Link>
      )}
    </Box>
  );
};

export default CustomButton;
